import "./PageTitle.css";
import React from "react";

function PageTitle({ title, className = "", margin = "20px auto 0", useH2InsteadOfH1 = false }) {
  return (
    <div className={"page-title-container " + className} style={{ "--margin": margin }}>
      {useH2InsteadOfH1 ? <h2 className='outfit-bold'>{title}</h2> : <h1 className='outfit-bold'>{title}</h1>}
    </div>
  );
}

export default PageTitle;
